declare var window: any;

import { Component, Vue } from 'vue-property-decorator';
import { ResumePayload } from '../../models/jobs/resumepayload';
import { vxm } from '@/store.vuex';
@Component
export default class ResumeValidator extends Vue {
  public resumePayload: ResumePayload = new ResumePayload();
  public resumeErrorMessage = '';
  validateFileFormate() {
    const vm = this;
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validateResume() {
    this.resumeErrorMessage = '';
    if (!this.resumePayload.resumefile) {
      this.resumeErrorMessage = 'Resume is required!';
      return;
    }
    this.resumePayload.resumefile && this.validationFileFormatResume();
    return !this.resumeErrorMessage;
  }

  validationFileFormatResume() {
    const vm = this;
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    if (this.resumePayload.resume.resumename.length > 250) {
      this.resumeErrorMessage =
        'You have exceeded the maximum character limit of 250 characters for file name';
      return;
    }

    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    if (!allowedResumeFormat.includes(ext)) {
      (this.resumeErrorMessage =
        fileNameFormat +
        ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`),
        'Upload Resume';
      vm.resumePayload.resumefile = '';
    }
  }
}
